import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewContainerRef, ViewChild, ComponentFactoryResolver, ComponentFactory } from '@angular/core';
import { AspObject } from '../asp/AspObject';
import * as utils from '../common/utils';

@Component({
  template: '<span class="prompt-span">{{prompt}}</span>'
})
export class UserActionBodyComponent {
  prompt: string;

  protected obj: AspObject;

  setObject(obj: AspObject) {
    this.obj = obj;
  }

  // Return any data entered by the user
  getData(): any {
    return undefined;
  }
}

@Component({
  selector: 'app-user-action',
  templateUrl: './user-action.component.html',
  styleUrls: ['./user-action.component.scss']
})
export class UserActionComponent implements OnInit {

  static readonly DIALOG_ID = 'userAction';

  title: string = 'USER ACTION';
  prompt: string;
  obj: AspObject;
  okButtonShown: boolean = false;

  @ViewChild('bodyContainer', { read: ViewContainerRef, static: true }) bodyContainer: ViewContainerRef;
 
  private bodyComponent: UserActionBodyComponent;
  private bodyComponentFactory: ComponentFactory<UserActionBodyComponent>;

  constructor(public dialogRef: MatDialogRef<UserActionComponent>,
              private compFactResolver: ComponentFactoryResolver,
              @Inject(MAT_DIALOG_DATA) private data: any) {
    this.title = data.title.toUpperCase();
    this.prompt = data.prompt;
    this.obj = data.obj;
  }

  static createDialogConfig(title: string, prompt: string, obj: AspObject) {
    const dialogConfig = utils.createDialogConfig(false, false, UserActionComponent.DIALOG_ID);
    dialogConfig.data = { title: title, prompt: prompt, obj: obj };
    return dialogConfig;
  }
  
  setBodyComponentFactory(fact: ComponentFactory<UserActionBodyComponent>) {
    this.bodyComponentFactory = fact;
  }

  showOkButton() {
    this.okButtonShown = true;
  }

  ngOnInit() {
    if (this.bodyComponentFactory) {
      // Use custom body
      this.bodyComponent = this.bodyContainer.createComponent(this.bodyComponentFactory).instance;
      this.bodyComponent.setObject(this.obj);
    }
    else {
      // Use default body
      this.bodyContainer.createComponent(this.compFactResolver.resolveComponentFactory(UserActionBodyComponent)).instance.prompt = this.prompt;
    }
  }
  
  onOk() {
    if (this.bodyComponent)
      this.dialogRef.close({ status: true, data: this.bodyComponent.getData() });
    else
      this.dialogRef.close();
  }

  onClose() {
    this.dialogRef.close();
  }
}
